var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-vh-100 h-100",attrs:{"id":"app"}},[(_vm.isPublic || _vm.isLoggedIn)?_c('router-view'):_c('div',{staticClass:"min-vw-100 min-vh-100 d-flex justify-content-center align-items-center"},[_c('i',{staticClass:"fad fa-spinner-third fa-spin fa-8x"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }